import { render, staticRenderFns } from "./HomeCommunications.vue?vue&type=template&id=f3f4c062&scoped=true&"
import script from "./HomeCommunications.vue?vue&type=script&lang=ts&"
export * from "./HomeCommunications.vue?vue&type=script&lang=ts&"
import style0 from "./HomeCommunications.vue?vue&type=style&index=0&id=f3f4c062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f4c062",
  null
  
)

export default component.exports